import React, { useState } from 'react';
import style from './Dropdown.module.less';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Icon } from 'edcom-ui';
import Menu from './Menu';
import AppLink from '../links/AppLink';

export default function Dropdown({ open = false, page, mobileOnly = false }) {
  const [menuExpanded, setMenuExpanded] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(false);

  const handleMenuExpanded = type => {
    if (!menuExpanded || currentMenuExpanded(type)) {
      setMenuExpanded(!menuExpanded);
    }
    setActiveSubmenu(type);
  };

  const currentMenuExpanded = type => {
    return type === activeSubmenu;
  };

  return (
    <div
      className={clsx(
        style.dropdown,
        mobileOnly && style.dropdownMobileOnly,
        open && style.dropdownOpen,
        page === 'search' && style.dropdownShort
      )}
    >
      <ul className={style.ulContainer}>
        {Menu.map(item => {
          const arrowIcon =
            menuExpanded && currentMenuExpanded(item.type)
              ? 'angle-up'
              : 'angle-down';
          return (
            <li
              key={item.type}
              className={clsx(
                style.liItems,
                menuExpanded && currentMenuExpanded(item.type) && style.openLi
              )}
              onClick={() => {
                handleMenuExpanded(item.type);
              }}
            >
              <span className={style.liSpan}>
                <span>{item.displayName}</span>
                <Icon name="angle-right" className={style.angleRight} />
                <Icon name={arrowIcon} className={style[`${arrowIcon}`]} />
              </span>
              <div className={clsx(style.sublinks)}>
                {item.sections.map((section, i) => {
                  return (
                    <ul key={i}>
                      <li className={style.liHeader}>{section.title}</li>
                      {section.links.map(l => {
                        let link = (
                          <AppLink href={l.link}>
                            {l.bold ? <strong>{l.title}</strong> : l.title}
                          </AppLink>
                        );
                        return <li key={l.title}>{link}</li>;
                      })}
                    </ul>
                  );
                })}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

Dropdown.propTypes = {
  open: PropTypes.bool,
  page: PropTypes.string,
  mobileOnly: PropTypes.bool,
};
